import {pageInfo} from './../api';
import {Message} from 'element-ui';
import {plant} from "../../../../api";

const interfaceLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    plantAreaObj: [],
    exportObj: []
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    }
  }
}
export default interfaceLog



// WEBPACK FOOTER //
// ./src/page/md/deviceGroupDetail/store/deviceGroupDetail.store.js